import { render, staticRenderFns } from "./SettingsSetup.vue?vue&type=template&id=efd4ae8c&scoped=true&"
import script from "./SettingsSetup.vue?vue&type=script&lang=js&"
export * from "./SettingsSetup.vue?vue&type=script&lang=js&"
import style0 from "./SettingsSetup.vue?vue&type=style&index=0&id=efd4ae8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efd4ae8c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('efd4ae8c')) {
      api.createRecord('efd4ae8c', component.options)
    } else {
      api.reload('efd4ae8c', component.options)
    }
    module.hot.accept("./SettingsSetup.vue?vue&type=template&id=efd4ae8c&scoped=true&", function () {
      api.rerender('efd4ae8c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/partners/SettingsSetup.vue"
export default component.exports